<template>
  <div class="resume">
    <div class="left">
      <!--<div id="person">
        <!--<img src="../../static/image/8222837.jpeg" />-->
      <!--</div>-->
      <div class="info">
        <i class="fa fa-map-marker" aria-hidden="true"></i>
        <span class="info_spans">{{address}}</span>
      </div>
      <div class="info">
        <i class="fa fa-mobile" aria-hidden="true"></i>
        <span class="info_spans">{{phone}}</span>
      </div>
      <div class="info">
        <i class="fa fa-envelope-o" aria-hidden="true"></i>
        <span class="info_spans">{{email}}</span>
      </div>
      <div class="info">
        <i class="fa fa-github" aria-hidden="true"></i>
        <span class="info_spans"><a :href="gitUrl" target="_blank">{{gitName}}</a></span>
      </div>
      <div class="info">
        <i class="fa fa-rss-square" aria-hidden="true"></i>
        <span class="info_spans"><a :href="blogUrl" target="_blank">我的博客</a></span>
      </div>
    </div>
    <div class="right">
      <h1>{{name}}</h1>
      <span>{{oneSentence}}</span>
      <div class="intro">
        <h3 class="title">项目经历</h3>
        <div class="splitLine"></div>
        <table>
          <tr v-for="(experience,index) in experiences" :key="index">
            <td class="time">{{experience.start}}</td>
            <td class="time">{{experience.end}}</td>
            <td class="company">{{experience.company}}</td>
            <td class="detail">{{experience.detail}}</td>
          </tr>
        </table>
      </div>
      <div class="intro">
        <h3 class="title">教育经历</h3>
        <div class="splitLine"></div>
        <table>
          <tr v-for="(education,index) in educations" :key="index">
            <td class="time">{{education.start}}</td>
            <td class="time">{{education.end}}</td>
            <td class="company">{{education.school}}</td>
            <td>{{education.major}}</td>
            <td>{{education.degree}}</td>
          </tr>
        </table>
      </div>
      <div class="intro">
        <h3 class="title">外语水平</h3>
        <div class="splitLine"></div>
        <table>
          <tr v-for="(language,index) in languages" :key="index">
            <td>{{language.name}}</td>
            <td>{{language.score}}</td>
          </tr>
        </table>
      </div>
      <div class="intro">
        <h3 class="title">专业技能</h3>
        <div class="splitLine"></div>
        <ul>
          <li v-for="(skill,index) in skills" :key="index">{{skill}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Resume',
  data () {
    return {
      address: '',
      phone: '',
      email: '',
      name: '',
      gitName: '',
      gitUrl: '',
      blogUrl: '',
      oneSentence: '',
      experiences: [],
      awards: [],
      educations: [],
      languages: [],
      skills: [],
      url: './static/data.json'
    }
  },
  beforeMount () {
    axios.get(this.url).then((res) => {
      this.address = res.data.address
      this.phone = res.data.phone
      this.email = res.data.email
      this.name = res.data.name
      this.gitUrl = res.data.gitUrl
      this.blogUrl = res.data.blogUrl
      this.oneSentence = res.data.oneSentence
      this.experiences = res.data.experiences
      this.gitName = res.data.gitName
      this.awards = res.data.awards
      this.educations = res.data.educations
      this.languages = res.data.languages
      this.skills = res.data.skills
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Resume.vue